import React from "react";
import { WebinarCardSection } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import Link from "next/link";
import VideoPlayer from "@/components/VideoPlayer";

interface WebinarsCardSectionProps {
  blok?: WebinarCardSection & SbBlokData;
}

const WebinarsCardSection: React.FC<WebinarsCardSectionProps> = ({ blok }) => {
  if (!blok) return null;

  const { title, description, items_manual } = blok;

  return (
    <div {...storyblokEditable(blok)} className="container py-4 py-md-5">
      <div className="row justify-content-center mb-4">
        <div className="col-lg-20 col-xl-18">
          <h2 className="text-center mb-4">{title}</h2>
          {description && (
            <p className="lead text-center mb-4">{description}</p>
          )}
        </div>
      </div>

      <div className="row g-5">
        {items_manual?.map((item) => (
          <div key={item._uid} className="col col-lg-12">
            <div className="card card-lighter h-100 overflow-hidden">
              {item.video_tag && (
                <VideoPlayer videoId={item.video_tag} />
              )}
              <div className="p-4 d-flex flex-column justify-content-between h-100">
                {item.title && <h3 className="text-secondary mb-2">{item.title}</h3>}
                {item.description && <p className="mb-4">{item.description}</p>}
                {item.cta_button && item.cta_button_link && (
                  <Link
                    href={item.cta_button_link.cached_url || '#'}
                    className="btn btn-secondary mt-auto"
                  >
                    {item.cta_button}
                  </Link>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WebinarsCardSection;